module.exports = "/_next/static/images/fcda04b1f74965ec6b7a78c698a19b33-bill-icon.svg";